export const IMAGE_CONFIG = {
    cloudinaryId: 'InstamartAssets/B2B%20Assets/Ads%20Platform/Swiggy_for_sellers',
    alt: 'Swiggy for sellers',
    dimension: 50,
};
export const DISALLOWED_ROUTES = {
    LOGIN: 'instamart/login',
    ACCOUNT_SELECT: 'instamart/account-select',
};
